import { uri, root as rootUrl } from "../../shared/endpoints";
import axios from "axios";

export const resetPassword = async (data) => {
  const Config = {
    baseURL: rootUrl,
    headers: { "Content-Type": "application/json" },
  }
  const axiosInstance = axios.create(Config);
  try {
    const passwordResponse = await axiosInstance.post(uri.resetPassword, data);
    console.log("passwordResponse.data------------------------", passwordResponse.data);
    return "success";
  }
  catch (err) {
    return null;
  }
};